import { render, staticRenderFns } from "./InventorySetting.vue?vue&type=template&id=d9d383ba&"
import script from "./InventorySetting.vue?vue&type=script&lang=js&"
export * from "./InventorySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports